// Dummy data hook for stacked salary bar chart
export default function useSalaryStackedBarData() {
  return [
    { month: 'Jan', salary: 40000, bonus: 5000, deductions: 2000 },
    { month: 'Feb', salary: 42000, bonus: 4000, deductions: 2500 },
    { month: 'Mar', salary: 41000, bonus: 6000, deductions: 3000 },
  ];
}
